import React from 'react';
import LayoutDashboard from '../../Components/Layout/LayoutDashboard';
import CardBranchDepartures from '../../Components/CardsBranches/CardBranchDepartures';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: "calc(100vh - 64px)",
		background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	title: {
		textAlign: "center",
		marginBottom: theme.spacing(6),
		fontWeight: 700,
		color: "#1a237e",
		textTransform: "uppercase",
		letterSpacing: "1px",
		textShadow: "0 2px 4px rgba(0,0,0,0.1)",
	},
	cardContainer: {
		display: "flex",
		justifyContent: "center",
	},
}));

const DeparturesAdmin = (props) => {
	const classes = useStyles();

	return (
		<LayoutDashboard>
			<Box className={classes.root}>
				<Container maxWidth="lg">
					<Typography variant="h3" className={classes.title}>
						Selecciona una Sucursal
					</Typography>
					<Box className={classes.cardContainer}>
						<CardBranchDepartures />
					</Box>
				</Container>
			</Box>
		</LayoutDashboard>
	);
};

export default DeparturesAdmin;
